/** Tech Complete uses existing completeJob only. No client status write. No new callable. */
import { pwaLiveWriteRegionError } from './ordersSurface';

export const PWA_COMPLETE_CONFIRM =
    'Complete this job via completeJob? Only active jobs move to Complete. Status is not patched on the client. Cancel shows COMPLETE · CANCELLED and leaves the job Active. No new callable.';

export const PWA_COMPLETE_BUSY = 'Completing…';

/** Confirm dismiss is a visible complete card. completeJob did not run. This is not a callable failure. */
export const COMPLETE_CANCELLED = {
    eyebrow: 'COMPLETE · CANCELLED',
    headline: 'Complete confirm was cancelled',
    body:
        'The confirm dialog was cancelled or dismissed. completeJob was not called. The job stays Active. Complete can be retried. This is not a callable failure.',
    cta: 'Retry Complete',
    note:
        'Accept the confirm to continue. Cancel does not call completeJob and does not patch status on the client. The job stays Active. Retry Complete asks again. This is not a completeJob failure.',
};

export function pwaCompleteCopy(surface?: string | null) {
    if (surface === 'cancelled') return COMPLETE_CANCELLED;
    return null;
}

/** Null and undefined become empty strings. A string keeps the same trim. */
function trimmedCompleteId(value: string | null | undefined): string {
    if (value == null) return '';
    return value.trim();
}

export function completeJobPayload(
    regionId: string | null | undefined,
    jobId: string | null | undefined,
): { regionId: string; jobId: string } {
    return { regionId: trimmedCompleteId(regionId), jobId: trimmedCompleteId(jobId) };
}

export function canCallCompleteJob(input: { regionId?: string | null; jobId?: string | null; status?: string }): boolean {
    if (pwaLiveWriteRegionError(input.regionId)) return false;
    return Boolean(input.regionId && input.jobId && input.status === 'active');
}

export async function completePwaJob(input: {
    callable: (data: { regionId: string; jobId: string }) => Promise<unknown>;
    regionId: string | null | undefined;
    jobId: string | null | undefined;
}): Promise<void> {
    const regionError = pwaLiveWriteRegionError(input.regionId);
    if (regionError) throw new Error(regionError);
    const payload = completeJobPayload(input.regionId, input.jobId);
    if (!payload.regionId || !payload.jobId) {
        throw new Error('regionId and jobId are required.');
    }
    await input.callable(payload);
}
